module.exports = __webpack_public_path__ + "img/web-foundation.eeb682d6.jpg";